<template>
  <div class="certification-IDCard">
    <div :id="idCardBackKey" class="title p-30 white-bg border-t border">{{props.titleOne}}</div>
    <div class="f-center f-column">
      <Camera :type="type" :fieldId="idCardBackFieldId" :bgImage="IDCardNegativeImage" :image="idCardBackUrl" bgImageClass="IDCardNegative-image" @onCaptured="(v) => onCaptured(idCardBackKey, v)" class="m-t-45 m-b-25" />
      <div class="title-sm" :id="idCardPositiveKey">身份人像面</div>
      <Camera :type="type" :fieldId="idCardPositiveFieldId" :bgImage="IDCardPositiveImage" :image="idCardPositiveUrl" bgImageClass="IDCardPositive-image" @onCaptured="(v) => onCaptured(idCardPositiveKey, v)" class="m-t-50 m-b-25" />
      <div class="title-sm">身份证国徽面</div>
      <div class="flex m-l-25 m-r-25 m-t-35 m-b-45">
        <img class="warning-image m-r-25" :src="warningImage">
        <div class="label">证件必须是清晰彩色原件电子版本。可以是扫描件或者数码拍摄照片。仅支持jpg、png的图片格式，小于5M。</div>
      </div>
    </div>
    <div class="title p-30 white-bg border-t border" :id="idCardUserKey">{{props.titleTow}}</div>
    <div class="f-center f-column">
      <div class="hold-demonstration m-t-50 m-b-50">
        <div class="subscript">参考示例</div>
        <img class="IDCardHold-image" :src="IDCardHoldImage">
      </div>
      <Camera :type="type" :fieldId="idCardUserFieldId" class="m-t-45 m-b-25" :image="idCardUserUrl" @onCaptured="(v) => onCaptured(idCardUserKey, v)" />
      <div class="flex m-l-25 m-r-25 m-t-35 m-b-60">
        <img class="warning-image m-r-25" :src="warningImage">
        <div class="label">请确保本人手持身份证，确保照片中面部及身份证清晰可见且无PS。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import Camera from '@/view/certification/components/Camera.vue'
import warningImage from '@/view/certification/assets/warning.png'
import IDCardPositiveImage from '@/view/certification/assets/IDCard-positive.png'
import IDCardNegativeImage from '@/view/certification/assets/IDCard-negative.png'
import IDCardHoldImage from '@/view/certification/assets/IDCard-hold.png'

export default {
  props: {
    titleOne: String,
    titleTow: String,
    idCardBackKey: String,
    idCardPositiveKey: String,
    idCardUserKey: String,
    idCardBackUrl: String,
    idCardPositiveUrl: String,
    idCardUserUrl: String,
    idCardBackFieldId: Number,
    idCardPositiveFieldId: Number,
    idCardUserFieldId: Number,
    type: {
      type: String,
      default: 'field'
    }
  },
  setup(props, { emit }) {
    const onCaptured = ( key, value ) => {
      emit('onCaptured', { key, value })
    }
    return {
      props,
      IDCardPositiveImage,
      IDCardNegativeImage,
      IDCardHoldImage,
      warningImage,
      onCaptured
    }
  },
  components: { Camera },
}
</script>

<style lang="scss">
@import '../style.scss';

.certification-IDCard {
  .title {
    font-size: 32px;
    font-weight: bold;
    color: #333333;
  }
  .title-sm {
    font-size: 30px;
    color: #333333;
  }
  .label {
    font-size: 28px;
    color: #666666;
  }
  .warning-image{
    width: 44px;
    height: 44px;
  }
  .hold-demonstration{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 308px;
    border: 1px solid #e9e9e9;
    background-color: #fff;
    border-radius: 15px;
    .subscript{
      position: absolute;
      top: 32px;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 168px;
      height: 52px;
      background: #3370FF;
      border-radius: 0px 26px 26px 0px;
      font-size: 30px;
      color: #FFFFFF;
    }
  }
}
</style>